var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6554 11.3666C24.4107 11.5674 25.0057 12.1643 25.2084 12.9196H25.2047C25.5713 14.2902 25.5713 17.1494 25.5713 17.1494C25.5713 17.1494 25.5713 20.0086 25.2047 21.3792C25.0039 22.1345 24.407 22.7296 23.6517 22.9322C22.2811 23.2988 16.7857 23.2988 16.7857 23.2988C16.7857 23.2988 11.2902 23.2988 9.91962 22.9322C9.1643 22.7314 8.56925 22.1345 8.36661 21.3792C8 20.0086 8 17.1494 8 17.1494C8 17.1494 8 14.2902 8.36661 12.9196C8.56925 12.1625 9.1643 11.5674 9.9233 11.3666C11.2939 11 16.7893 11 16.7893 11C16.7893 11 22.2847 11 23.6554 11.3666ZM19.5952 17.1494L15.0301 19.7857V14.5132L19.5952 17.1494Z",
    fill: "#9B9C9C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589286,
    y: 0.589286,
    width: 31.8214,
    height: 31.8214,
    rx: 15.9107,
    stroke: "#9B9C9C",
    strokeWidth: 1.17857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.fa25adcce27311b5eeb5e0dbd7cfbcc8.svg";
export { ForwardRef as ReactComponent };